"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleIcon = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const ToggleIcon = exports.ToggleIcon = (0, _mui.styled)(_components.IconButton)(({
  ownerState: {
    isOpen
  }
}) => ({
  cursor: 'pointer',
  fontSize: '3.2rem',
  padding: 0,
  position: 'relative',
  transition: 'transform 300ms',
  transform: `rotate(${isOpen ? 180 : 0}deg)`
}));